import { render } from "./GameBoard.vue?vue&type=template&id=4354c987&scoped=true"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"

import "./GameBoard.vue?vue&type=style&index=0&id=4354c987&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4354c987"]])

export default __exports__